/* eslint-disable no-unused-vars */
import React, { useEffect, useState} from 'react'
import axios from 'axios';
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import './iatas_style.css'

function Iatas() {
  const [users, setUsers] = useState([])
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [loading, setLoading] = useState(true)
  const [searchValue, setSearchValue] = useState("");
  
  const getUsers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/iatas`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
        },
      });
      if (res.data.code === 1){
        setUsers(res.data.users)
        setLoading(false)
      }
      
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
      setLoading(true)
    }
  };
  
  const deleteUser = async (id) => {
    try {
      // Confirmación del usuario
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        // Validar que el ID es válido
        if (!id) {
          throw new Error("ID de usuario no válido.");
        }

        // Realizar la solicitud de eliminación
        const response = await axios.delete(
          `${process.env.REACT_APP_URL_BACKEND}/iatas/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        // Validar la respuesta del servidor
        if (response.status === 200) {
          Swal.fire("¡Eliminado!", "Iata ha sido eliminada.", "success");
          setUpdateTrigger(prev => !prev); // Actualizar la interfaz
        } else {
          throw new Error("Error al procesar la solicitud de eliminación.");
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Tu Iata está a salvo :)", "error");
      }
    } catch (error) {
      console.error("Error al eliminar Iata:", error);  // Mejor registro de errores
      Swal.fire(
        "Error",
        error.response?.data?.message || "Hubo un error al intentar eliminar la Iata. Por favor, intenta más tarde.",
        "error"
      );
    }
  };

  
  const updateUser = async (id) => {
    try {
      // Validar que el ID es válido
      if (!id) {
        throw new Error("ID de usuario no válido.");
      }

      // Obtener los datos del usuario a editar del servidor
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/iatas/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
          },
        }
      );

      if (!response.data.user || response.data.user.length === 0) {
        throw new Error("Usuario no encontrado.");
      }

      const userData = response.data.user[0];

      const result = await Swal.fire({
        title: "Editar Iata",
        html:
          '<div class="form-grid">' +
          `<input type="text" id="code" class="swal2-input" placeholder="MEX" value="${userData.code}">` +
          `<input type="text" id="name" class="swal2-input" placeholder="Nombre Aeropuerto" value="${userData.name}">` +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Actualizar",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              code: document.getElementById("code").value,
              name: document.getElementById("name").value,
              id: id,
            });
          });
        },
      });

      if (result.isConfirmed) {
        const updatedUserData = result.value;

        // Realizar la solicitud PUT al servidor para actualizar el usuario
        const updateResponse = await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/iatas/update`,
          updatedUserData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );

        // Verificar respuesta del servidor
        if (updateResponse.status === 200) {
          Swal.fire("¡Actualizado!", "Iata actualizada exitosamente.", "success");
          setUpdateTrigger(prev => !prev); // Actualizar la interfaz
        } else {
          throw new Error("Error al procesar la actualización.");
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "No se ha realizado ninguna actualización.", "error");
      }
    } catch (error) {
      console.error("Error al actualizar Iata:", error); // Mejor registro de errores
      Swal.fire(
        "Error",
        error.response?.data?.message || "Hubo un error al intentar actualizar la Iata. Por favor, intenta más tarde.",
        "error"
      );
    }
  };

  
  const createUser = async () => {
    try {
      const result = await Swal.fire({
        title: "Crear Iata",
        html:
          '<div class="form-grid">' +
          '<input type="text" id="code" class="swal2-input" placeholder="MEX">' +
          '<input type="text" id="name" class="swal2-input" placeholder="Nombre Aeropuerto">' +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              code: document.getElementById("code").value,
              name: document.getElementById("name").value,
            });
          });
        },
      });
  
      if (result.isConfirmed) {
        const userData = result.value;
  
        const response = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/iatas/create`,
          userData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire(
          "¡Creado!",
          "La iata ha sido creada exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Accion cancelada.", "error");
      }
    } catch (error) {
      if (error.response.data.message === "La iata ya existe") {
        Swal.fire("Error al crear la iata", "La iata ya existe.", "error");
      } else if (error.response.data.message === "La iata fue eliminada anteriormente") {
        Swal.fire("Error al crear la iata", "La iata fue eliminada anteriormente", "error");
      } else if (error.response.data.errors[0] === "La contraseña debe ser mayor a 6 caracteres") {
        Swal.fire("Error al crear la iata", "La contraseña debe ser mayor a 6 caracteres", "error");
      } else if (error.response.data.errors[0] === "El formato del correo no es valido") {
        Swal.fire("Error al crear la iata", "El formato del correo no es valido", "error");
      } else {
        Swal.fire(
          "Error al crear la iata",
          "No se ha creado ningúna iata."
        );
      }
    }
  };
  
  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };
  
  const filteredUsers = searchValue
  ? users.filter(
      (user) =>
        user.name
          .toUpperCase()
          .includes(searchValue.toUpperCase()) ||
        user.email.toUpperCase().includes(searchValue.toUpperCase())
    )
  : users

  useEffect(() => {
    getUsers();
  }, [updateTrigger]);

  return (
    <>
    <div className="panel-table">
    <div className='colum-left'>
      <input type="text" className='searchInput' id="searchInput" placeholder="Buscar..." />
      <button className='btnn' onClick={handleSearch}>Buscar</button>
    </div>
    <div className='colum-rigth'>
      <button className="btnn" onClick={createUser}>
        Crear Iata
      </button>
    </div>
    </div>
    <div className='table-responsive'>
      <table className='table table-preve' id='tableToSearch'>
        <thead>
          <tr>
            <th>Código</th>
            <th>Nombre</th>
            <td className='accions'>Acciones</td>
          </tr>
        </thead>
        
        <tbody>
        {loading ? (<tr><td>Cargando...</td></tr>) : 
        ( filteredUsers.map((user) => (
          <tr key={user.email} data-master-id={user.code}>
            <td>{user.code}</td>
            <td>{user.name}</td>
            <td>
            <FaEdit className='editButton' onClick={() =>{ updateUser(user.id)}}/>
            <FaTimes className='deleteButton' onClick={() =>{ deleteUser(user.id)}}/>
            </td>
          </tr>
        )))}
        </tbody>
      </table>
    </div>
    </>
  )
}

export default Iatas